import { Injector } from '@angular/core';
import { AvailabilityMonitor } from '../utilities/availability-monitor';

/**
 * Loads the main application configuration
 * @param injector
 */
export const loadAvailabilityMonitor = (injector: Injector): Promise<void> => new Promise((resolve) => {
	const availabilityMonitor = injector.get(AvailabilityMonitor);
	availabilityMonitor.start$().subscribe(() => resolve());
});
